function internalSetHref(url: string) {
  window.location.href = url;
}

(window as any).setLocationHref = internalSetHref;

export default window as any as { setLocationHref: (url: string) => void };
